import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as c, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconEvernote",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function _(e, t, r, u, f, a) {
  return i(), c("svg", {
    "aria-label": r.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--evernote"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Evernote",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      d: "M22.007 12.614c.075 1.27-.06 2.525-.229 3.783-.168 1.284-.38 2.562-.723 3.813-.224.8-.504 1.575-.901 2.306-.488.894-1.226 1.402-2.244 1.443l-2.874.027c-.477-.013-.958-.11-1.425-.223-.894-.225-1.397-.825-1.545-1.725-.14-.81-.13-1.64.03-2.448.189-.922.75-1.47 1.675-1.577.613-.075 1.238-.058 1.857-.075.154-.005.207.073.153.215a2.021 2.021 0 0 0-.074 1.217c.04.155-.017.23-.195.229a5.823 5.823 0 0 0-.842.04c-.477.064-.72.352-.72.834 0 .154.02.312.05.466.077.38.337.585.707.628.843.095 1.686.104 2.528-.038.506-.085.81-.404.87-.905.114-.976.116-1.94-.171-2.884-.248-.82-.755-1.174-1.6-1.275l-2.52-.405c-.796-.145-1.275-.665-1.44-1.425-.098-.43-.106-.878-.161-1.318-.01-.08-.055-.156-.075-.225-.03.075-.08.159-.088.244-.05.51-.04 1.03-.139 1.53-.12.6-.303 1.175-.502 1.748-.139.401-.462.628-.904.6a28.321 28.321 0 0 1-5.342-1.015l-.48-.155c-.695-.195-1.115-.677-1.305-1.34l-.75-2.89-.555-3.225c-.086-.566-.15-1.142-.062-1.72.115-.834.685-1.427 1.53-1.473l2.668-.046c.096 0 .19.002.28-.02a.923.923 0 0 0 .758-.941l-.038-2.277C7.173.93 7.809.327 8.826.146a7.935 7.935 0 0 1 3.682.195c.7.206 1.1.692 1.287 1.372.043.165.11.225.277.215l1.937.008 2.5.277c.514.072 1.023.188 1.523.315.874.224 1.345.834 1.472 1.692l.268 2.517.225 4.182.007 1.708.003-.014Zm-3.4-.867c-.015-.5-.053-.95-.333-1.338a1.244 1.244 0 0 0-1.852-.112c-.273.3-.37.66-.423 1.05-.006.025.08.094.12.094l.6-.04c.576.006 1.142.085 1.688.295.049.02.102.03.198.058l.002-.007ZM6.59.866a2.865 2.865 0 0 0-.208 1.194l.037 2.2c.004.268-.056.338-.324.338l-2.27.019c-.437 0-.857.075-1.166.209l3.9-4c.015.01.03.025.045.04H6.59Z",
      fill: "#00A82D"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ o(s, [["render", _]]);
export {
  b as default
};
//# sourceMappingURL=evernote.js.map
